<div class="calendar-container">
      <div class="calendar-top">
      <label> Date</label>
      <input type="date" id="date" class="form-control" name="date" (change)="onDateChange($event)" 
        [min]="minDateTime" required />
  </div>
<div class="calendar-wrapper">
 <full-calendar #fullcalendar [options]="calendarOptions"></full-calendar>
</div>

 <div class="details-wrapper" *ngIf="selectedEvent">
    <h3>Follow Up Details</h3>
    <p><b>Title:</b> {{ selectedEvent.title }}</p>
    <p><b>Follow up Date:</b> {{ selectedEvent.start | date:'short' }}</p>
    <p><b>Remarks:</b> {{ selectedEvent.extendedProps?.remarks }}</p>
    <p><b>Property:</b> {{ selectedEvent.extendedProps?.property }}</p>
    <p><b>Product Value:</b> {{ selectedEvent.extendedProps?.productValue }}</p>
    <p><b>Custumer Name:</b> {{ selectedEvent.extendedProps?.name }}</p>
    <p><b>Mobile:</b> {{ selectedEvent.extendedProps?.mobile }}</p>
    <p><b>Email:</b> {{ selectedEvent.extendedProps?.email }}</p>
  </div>
</div>
